module.exports = __webpack_public_path__ + "static/media/zhengs2-0@2x.4ab83172.png";